import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {addComma} from '../../utils/utils';
gsap.registerPlugin(ScrollTrigger);

const duration = 0.8;
const division = 50;

// Ease-in-quad function
function easeInQuad(t: number): number {
  return t * t;
}

// Generate random number between 0 and 9
function getRandomNum(): number {
  return Math.floor(Math.random() * 10);
}

export const numRoller = (): void => {
  const numRollers = document.querySelectorAll('.c-rolled-num');
  numRollers.forEach((numRoller) => {
    const elm = numRoller as HTMLElement;
    const delay = parseFloat((numRoller as HTMLElement).dataset.delay || '0');
    const num = parseInt((numRoller as HTMLElement).dataset.num || '0');
    const isOne = (numRoller as HTMLElement).dataset.isOne === 'true';
    gsap.to(numRoller, {
      scrollTrigger: {
        trigger: numRoller,
        start: 'top 80%',
        onEnter: () => {
          rollNum(elm, num, delay, isOne);
        },
      },
    });
  });
};

function rollNum(elm: HTMLElement, num: number, delay: number, isOne: boolean): void {
  let curNum = 0;
  const totalSteps = division;
  const stepDuration = (duration * 1000) / totalSteps;

  setTimeout(() => {
    let step = 0;
    const rollInterval = setInterval(() => {
      const progress = step / totalSteps;
      const easedProgress = easeInQuad(progress);

      if (isOne) {
        // For slot machine effect, show random numbers until near the end
        if (progress < 0.8) {
          // Show random numbers during the first 80% of the animation
          curNum = getRandomNum();
        } else {
          // Gradually increase probability of showing the target number
          const targetProb = (progress - 0.8) * 5; // Scale 0.8-1.0 to 0-1
          curNum = Math.random() < targetProb ? num : getRandomNum();
        }
      } else {
        // Original smooth counting behavior
        const nextNum = Math.floor(num * easedProgress);
        const increment = nextNum - curNum;
        if (increment > 0) {
          curNum = nextNum;
        }
      }

      elm.innerHTML = addComma(curNum);

      step++;
      if (step >= totalSteps) {
        clearInterval(rollInterval);
        elm.innerHTML = addComma(num); // Ensure we end at the exact target number
      }
    }, stepDuration);
  }, delay * 1000);
}
